import type { MagentoApiAddProductsToCartMutationResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export type AddPromoGiftToCartArg = {
  cartId: string;
  items: Array<{ sku: string; quantity: number; salesRuleId: number; selectedOptions?: string[] }>;
};

export const addPromoGiftToCartEndpoint = (builder: MagentoApiBuilder) => ({
  addPromoGiftToCart: builder.mutation<MagentoApiAddProductsToCartMutationResponse, AddPromoGiftToCartArg>({
    query: ({ cartId, items }) => {
      const cartItems = items
        .filter(({ quantity }) => quantity > 0)
        .map(({ sku, quantity, salesRuleId, selectedOptions }) => ({
          sku,
          quantity,
          entered_options: [
            { uid: btoa("custom-option/is_gift"), value: "true" },
            { uid: btoa("custom-option/is_salesrule_gift"), value: "true" },
            { uid: btoa("custom-option/gift_salesrule_id"), value: String(salesRuleId) },
          ],
          ...(selectedOptions?.length && { selected_options: selectedOptions }),
        }));

      return {
        method: "addProductsToCart",
        params: [{ cartId, cartItems }],
      };
    },
    invalidatesTags: [TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES],
  }),
});
